﻿'use strict'
import { App, View } from '../../config/app.js'
import { currentUser, getErrorCode, getErrorMessage } from '../../helper.js'
import { Modal } from '../../modal.js'

export default async function ()
{
	App.Modal.NameChange = new Modal('NameChange', {
		view: View.create({
			name: 'account/modalNameChange',
			model: currentUser()
		}),
		onActionAfter: (modal, e) =>
		{
			if (!e.detail.success && getErrorCode(e) == 'wrong_password')
			{
				e.stopPropagation()
				const passwordInput = modal.element.querySelector('.modal-body [name="nameChange[password]"]')
				passwordInput.setCustomValidity(getErrorMessage(e))
				passwordInput.reportValidity()
			}
		}
	})
}
